import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import OutlinedButton from "../Form/OutlinedButton";
import { productData, productSlider } from "../../data/carousel";
import { ReactComponent as RightBtn } from "../../static/svg/right-btn.svg";
import { ReactComponent as LeftBtn } from "../../static/svg/left-btn.svg";

function SampleNextArrow(props) {
  return (
    <Box className="absolute top-[40%] z-10 right-0 opacity-75 hover:opacity-100">
      <RightBtn className="cursor-pointer" onClick={props.onClick} />
    </Box>
  );
}

function SamplePrevArrow(props) {
  return (
    <Box className="absolute top-[40%] z-10 left-0 opacity-75 hover:opacity-100">
      <LeftBtn className="cursor-pointer" onClick={props.onClick} />
    </Box>
  );
}

export const ViewProductSlider = ({ data }) => {
  let navigate = useNavigate();
  const [slideIndex, setSlideIndex] = useState(0);

  const settings = {
    centerMode: true,
    centerPadding: "0px",
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2500,
    beforeChange: (current, next) => setSlideIndex(next),
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  return (
    <div className="slider !w-full overflow-hidden -mb-2">
      <Slider {...settings}>
        {/* {data &&
          data.map((caro, index) => (
            <div key={index} className="relative">
              <img
                src={caro.imgSrc}
                alt={caro.name}
                className="object-contain  w-full md:h-[600px] h-[500px] overflow-hidden"
                //   h-[400px] w-[500px] object-cover
              />
            </div>
          ))} */}
        {data && (
          <div className="relative">
            <img
              src={data.imgSrc}
              alt={data.name}
              className="object-contain  w-full md:h-[600px] h-[500px] overflow-hidden"
              //   h-[400px] w-[500px] object-cover
              draggable={false}
            />
          </div>
        )}
      </Slider>
    </div>
  );
};
